/// <amd-module name="Build/DesignerExtensions/TaskCheckPanel/Generated/Constants" />
//----------------------------------------------------------
// Generated file, DO NOT EDIT.
// To regenerate this file, run "GenerateConstants.cmd" .

// Generated data for the following assemblies:
// Microsoft.Azure.Pipelines.TaskCheck.WebApi
// Microsoft.Azure.Pipelines.Checks.WebApi
// Microsoft.Azure.Pipelines.Checks.Common
//----------------------------------------------------------


export module Constants {
    export const DEFAULT_RETRY_INTERVAL_IN_MINUTES = 0;
    export const DEFAULT_TIMEOUT_IN_MINUTES = 1440;
    export const MAX_TIMEOUT_VALUE_IN_MINUTES = 43200;
}

export module FeatureFlagConstants {
    export const EnableChecksScalabilityPhase1Warnings = "Pipelines.Checks.EnableChecksScalabilityPhase1Warnings";
    export const EnableChecksScalabilityPhase2Errors = "Pipelines.Checks.EnableChecksScalabilityPhase2Errors";
    export const EnableChecksScalabilityPhase3FailCheckRuns = "Pipelines.Checks.EnableChecksScalabilityPhase3FailCheckRuns";
    export const EnableChecksScalabilityResourceIssues = "Pipelines.Checks.EnableChecksScalabilityResourceIssues";
    export const EnableDisabledChecksFeature = "Pipelines.Checks.EnableDisabledChecksFeature";
    export const ResourceListOptimizations = "Pipelines.Policy.ResourceListOptimizations";
}

export module ResourceTypeNames {
    export const ServiceEndpoint = "endpoint";
    export const Queue = "queue";
    export const SecureFile = "securefile";
    export const VariableGroup = "variablegroup";
    export const Environment = "environment";
    export const AgentPool = "agentpool";
    export const Repository = "repository";
}

export module TaskCheckConstants {
    export const TaskCheckTypeId = "fe1de3ee-a436-41b4-bb20-f6eb4cb879a7";
    export const InvokeRestApiTaskId = "9c3e8943-130d-4c78-ac63-8af81df62dfb";
    export const AzureFunctionTaskId = "537fdb7a-a601-4537-aa70-92645a2b5ce4";
    export const TaskCheckTypeName = "Task Check";
    export const TaskCheckMaxSyncRetries = "TaskCheck.MaxSyncRetries";
    export const TaskCheckScalabilityComplianceDeadline = "TaskCheck.ScalabilityComplianceDeadline";
    export const TaskCheckDefaultRetryIntervalInMinutes = "TaskCheck.DefaultRetryIntervalInMinutes";
    export const TaskCheckDefaultTimeoutInMinutes = "TaskCheck.DefaultTimeoutInMinutes";
}

export module TaskCheckLabels {
    export const DISPLAY_NAME = "displayName";
    export const VARIABLE_GROUP = "linkedVariableGroup";
    export const COMPLETION_OPTIONS_GROUP_NAME = "completionOptions";
    export const CONTROLS_OPTIONS_GROUP_NAME = "controlOptions";
    export const WAIT_FOR_COMPLETION = "waitForCompletion";
    export const RETRY_INTERVAL = "retryInterval";
    export const TIMEOUT = "timeout";
}

